const Squircle = () => {
	return (
	  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
	    <clipPath id="squircle" clipPathUnits="objectBoundingBox">
	    <path d="M0.055,0.347 C0.148,0,0.242,-0.054,0.589,0.039 L0.65,0.055 C0.997,0.148,1,0.242,0.958,0.589 L0.942,0.65 C0.849,0.997,0.755,1,0.408,0.958 L0.347,0.942 C0,0.849,-0.054,0.755,0.039,0.408 L0.055,0.347" fill="#4ADE80"/>
	    </clipPath>
	  </svg>
	)
}
export default Squircle
